module.exports = __webpack_public_path__ + "img/boolzap.572d7f8a.gif";